import routing from './integralEvaluation.route'
import run from './integralEvaluation.run'

// teacher self assessment controller
import teacherSelfAssessmentController from './teacherSelfAssessment/teacherSelfAssessmentController'
import teacherAssessmentController from './teacherAssessment/teacherAssessmentController'

import integralEvaluationSrv from './integralEvaluationSrv'

import GlobalConfig from '../../../globals/globalConfig.json'

export default angular.module('app.evaluations', [ integralEvaluationSrv ])
	.config(routing)
	.run(run)
	.controller('teacherSelfAssessmentController', teacherSelfAssessmentController)
	.controller('teacherAssessmentController', teacherAssessmentController)
	.constant('integralEvaluation', [ {
		title   : 'Evaluación integral',
		icon    : 'mdi-action-assignment-turned-in',
		moduleId: GlobalConfig.menuModulesId.integralEvaluation,
		url     : GlobalConfig.externalURLs.integralEvaluationURL,
		/*subMenu: [
			{
			  title: 'Autoevaluación Docente',
			  rolesAllowed: [GlobalConfig.userRolesIds.approver],
			  url: 'evaluations.teacherSelfAssessment'
			},
			{
			  title: 'Evaluación Docente',
			  rolesAllowed: [GlobalConfig.userRolesIds.approver],
			  url: 'evaluations.teacherAssessment'
			}
		  ],*/

	} ]).directive('ngOnkeyup', function() {
		return {
			restrict: 'A',
			scope   : {
				func: '&ngOnkeyup',
			},
			link: function(scope, elem, attrs) {
				elem.bind('keyup', scope.func)
			},
		}
	})
	.name



// WEBPACK FOOTER //
// ./src/app/u-faculty/integralEvaluation/index.js